<template>
  <form data-vv-scope="entity-docdigital">
    <div class="row mb-5">
      <div class="col-12 mt-3">
        <list-subject-types
          autocomplete
          class="w-100"
          :clearable="false"
          :danger="errors.has('entity-docdigital.entity')"
          :danger-text="errors.first('entity-docdigital.entity')"
          data-vv-as="entidad"
          label="Entidad"
          name="entity"
          ref="subjectEntity"
          v-model="editGroup.entidadDocDigital"
          v-validate="'required'"
          data-cy="entity"
        />
      </div>
      <div class="col-md-12 mt-3">
        <div style="float: right">
          <vs-button
            class="action"
            color="primary"
            type="border"
            @click="saveChanges()"
            icon="save"
            data-cy="save"
          >
            Guardar
          </vs-button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import ListSubjectTypes from '@/febos/chile/docDigital/components/subject/ListSubjectTypes';

export default {
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  components: {
    ListSubjectTypes
  },
  data() {
    return {
      editGroup: {
        ...this.group,
        entidadDocDigital: ''
      }
    };
  },
  created() {
    if (this.group.entidadDocDigital) {
      this.editGroup.entidadDocDigital = this.group.entidadDocDigital.toString();
    }
  },
  watch: {
    group(newValue) {
      this.editGroup = { ...newValue };
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('Herramientas', [
      'categoryRegions',
      'categoryServices'
    ]),
    showModal: {
      get() {
        return this.modalName === 'modalEntityDocDigital';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Empresas', [
      'updateGroup'
    ]),
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async saveChanges() {
      const isValid = await this.validateForm('entity-docdigital');
      if (!isValid) {
        return;
      }
      const group = {
        ...this.editGroup,
        entidadDocDigital: parseInt(this.editGroup.entidadDocDigital, 10)
      };

      group.esOficina = 'Y';
      group.esDivision = 'N';

      await this.updateGroup({
        empresaId: this.company.id,
        group
      });

      this.$emit('close-action');
    }
  }
};
</script>
